export const WholesaleOrderDetails = () => {
    return <div>Wholesale Order Details Component</div>;
};
